import { createStore, combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import hotelSearchReducer from './reducers/hotelSearchReducer';
import hotelListingReducer from './reducers/hotelListingReducer';
import hotelDetailReducer from './reducers/hotelDetailReducer';
import hotelCheckoutReducer from './reducers/hotelCheckoutReducer';
import currencyReducer from './reducers/currencyReducer';
import loginuserReducer from './reducers/loginUserReducer';
// Combine reducers
const rootReducer = combineReducers({
  hotelSearch: hotelSearchReducer,
  hotelListing: hotelListingReducer,
  hotelDetail: hotelDetailReducer,
  hotelCheckout: hotelCheckoutReducer,
  currency:currencyReducer,
  user:loginuserReducer,
});
const persistConfig = {
  key: 'root', // root key in local storage
  storage,
};

// Create store
const persistedReducer = persistReducer(persistConfig, rootReducer);
  
  const store = createStore(persistedReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
  const persistor = persistStore(store);
  
  export { store, persistor };
